import { useTheme } from '@/contexts/ThemeContext';
import { Moon, Sun } from 'lucide-react';
import React from 'react';
import { twc } from 'react-twc';

const ThemeToggle: React.FC = () => {
  const { toggleTheme, isDark } = useTheme();

  return (
    <Button onClick={toggleTheme} aria-label="Toggle theme">
      {isDark ? <Moon className="text-text-black" /> : <Sun className="text-text-black" />}
    </Button>
  );
};

const Button = twc.button`h-8 w-8 flex items-center gap-1 bg-transparent border border-solid border-border-light-line-1 rounded-md text-xs font-normal text-text-black cursor-pointer hover:opacity-80`;

export default ThemeToggle;
